import Caption from 'LuxKit/Typography/Caption'
import { FormattedMessage } from 'react-intl'

interface Props {
  departureCity?: string
  destinationCity?: string
}

export function HeroCruiseLocation({ destinationCity, departureCity }: Props) {
  return (
    <Caption variant="large" colour="normal-contrast">
      {departureCity === destinationCity && <FormattedMessage
        id="oSCcDGA97NZTUPZmj6Ku"
        defaultMessage="Starts and ends in <b>{departureCity}</b>"
        
        values={{
          departureCity,
          b: (chunks) => <b>{chunks}</b>,
        }}
      />}
      {departureCity !== destinationCity && <FormattedMessage
        id="SjfwU-O5N60Jfw1hfKca"
        defaultMessage="Starts in <b>{departureCity}</b>. Ends in <b>{destinationCity}</b>"
        
        values={{
          departureCity,
          destinationCity,
          b: (chunks) => <b>{chunks}</b>,
        }}
      />}
    </Caption>
  )
}
